// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__T1E2A"};